export default __webpack_public_path__ + "locales/az/Common.json?hash=bb188676caa7f7f924397e11c1a9a85f";